module.exports = __webpack_public_path__ + "Flag-772.335d11bbc079e08f25fe307f44f60f72.svg";